import { combineReducers } from '@reduxjs/toolkit';
import { createCustomSlice } from 'store/store.utils';
import {
  createStockAsyncThunk,
  getStockListAsyncThunk,
  getStockListByIdsAsyncThunk,
  getStockListByTypeAsyncThunk,
  updateStockAsyncThunk,
} from './stock.action';

const stockListSlice = createCustomSlice(
  'stock/stockList',
  getStockListAsyncThunk
);
const stockListByTypeSlice = createCustomSlice(
  'stock/stockListByType',
  getStockListByTypeAsyncThunk
);
const stockListByIdsSlice = createCustomSlice(
  'stock/stockListByIds',
  getStockListByIdsAsyncThunk
);
const stockCreateSlice = createCustomSlice(
  'stock/createStock',
  createStockAsyncThunk
);
const stockUpdateSlice = createCustomSlice(
  'stock/updateStock',
  updateStockAsyncThunk
);

export const { reset: resetStockList } = stockListSlice.actions;
export const { reset: resetStockCreate } = stockCreateSlice.actions;
export const { reset: resetStockUpdate } = stockUpdateSlice.actions;

export const stockReducer = combineReducers({
  stockList: stockListSlice.reducer,
  stockListByType: stockListByTypeSlice.reducer,
  stockListByIds: stockListByIdsSlice.reducer,
  createStock: stockCreateSlice.reducer,
  updateStock: stockUpdateSlice.reducer,
});
